import React, {Component} from 'react'
import ProfileBase from './helpers/ProfileBase'
import EducationBox from './helpers/EducationBox'
import TestAnswersBox from './helpers/TestAnswersBox'
import AdditionalTalentNotesBox from './helpers/AdditionalTalentNotesBox'

class BookerProfile extends Component {
  render() {
    return (
      <ProfileBase profileUrlPart="booker" render={( profileData ) => (
        <div>
          {profileData.ProfileType === 'Booker' &&
            <div>
              <div className="row">
                <div className="col-md-6 widget">
                  <div className="title">Experience</div>
                  <div className="row">
                    <div className="col">
                      <div className="row">
                        <div className="col-4">Additional experience:</div>
                        <div className="col-8">{profileData.Experience}</div>
                      </div>
                      <div className="row">
                        <div className="col-4">Studios:</div>
                        <div className="col-8">{profileData.LocalizationCompanies}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <AdditionalTalentNotesBox additionalNotes={profileData.AdditionalNotes} />
              </div>
            </div>
          }
        </div>
      )}/>
    )
  }
}

export default BookerProfile
